import React, { Component } from "react";
import ServiceOne from "../../elements/service/ServiceOne";
import { LanguageContext } from '../../context/LanguageContext';
import translations from '../../translations';

class SliderOne extends Component {
  static contextType = LanguageContext;

  render() {
    const { language } = this.context;
    const t = translations[language];
    const isArabic = language === 'ar';

    return (
        <div className="slider-activation">
            {/* Start Single Slide */}
            <div className="slide slide-style-1 slider-fixed--height d-flex align-items-center bg_image bg_image--1" data-black-overlay="6">
                <div className="container position-relative">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className={`inner ${isArabic ? 'text-right' : ''}`} dir={isArabic ? 'rtl' : 'ltr'}>
                                <span className="subtitle theme-gradient">{t.homepage.slider.subtitle}</span>
                                <h1 className="title theme-gradient">{t.homepage.slider.title}</h1>
                            </div>
                        </div>
                    </div>
                    {/* Start Service Area */}
                    <div className="service-wrapper service-white">
                        <ServiceOne />
                    </div>
                    {/* End Service Area */}
                </div>
            </div>
            {/* End Single Slide */}
        </div>
    );
  }
}
export default SliderOne;